import React, { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../Store";
import { Graph_QL, useMilestones } from "../../../Services";
import { ValueType } from "../../../Definitions";

export const useMilestoneOptions = () => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getMilestoneInfo, data: milestonesState} = useMilestones(connection);

  useEffect(() => {
    getMilestoneInfo({fetchAmount: 500})
  }, []);

  const milestoneOptions: ValueType[] = useMemo(() => {
    if (milestonesState && milestonesState[domain]) {
      return milestonesState[domain].data.map(milestone => ({
        label: milestone.name,
        id: milestone.milestone_id
      }))
    }
    return []
  }, [domain, milestonesState])

  return milestoneOptions;
};
